const EN_US = { 'tdsPlaygroundDomain.title': 'Tds Playground' } as const

export default EN_US
